import './Statistics.css';
import { useState, useEffect, ReactNode } from 'react'
import { Button } from "react-bootstrap";
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, BarChart, Bar } from 'recharts';
import { Link } from 'react-router-dom'
import ConsoleNavMenu from '../console/ConsoleNavMenu';
import { APIRequestGet, APIRequestPost } from '../../utils/APIRequests';
import { FullStatisticSchema, LifetimeStatisticDataList, LogInfoDataList, LogInfoListSchema, StatisticGetLogsSizeSchema, VisitsByDayData } from '../../api/Statistic';
import firmware from '../../utils/firmware';

interface CustomTooltipProps {
    active: boolean;
    payload: unknown;
    label: string;
}

const CustomTooltip = ({ active, payload, label }: CustomTooltipProps) => {
    const isVisible = active && payload && payload.length;
    return (
        <div className="custom-tooltip" style={{ visibility: isVisible ? 'visible' : 'hidden', backgroundColor: "white", padding: "10px" }}>
            {isVisible && (
                <>
                    <p style={{ color: "black" }}>{`${label} : ${payload[0].value}`}</p>
                </>
            )}
        </div>
    );
};

function Statistic(): ReactNode {
    // const data1 = [6, 0, 0, 0, 0, 0, 0];
    const [uniqueVisitsByDay, setUniqueVisitsByDay] = useState<{ count: number, name: string }[]>([]);
    const [lifetime, setLifetime] = useState<LifetimeStatisticDataList>([]);
    const [logs, setLogs] = useState<LogInfoDataList>([]);
    const [logPage, setLogPage] = useState<number>(0);
    const [logsSize, setLogsSize] = useState<number>(0);
    const [visitsByMonth, setVisitsByMonth] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const [modemsLifetime, _setModemsLifetime] = useState([]);

    useEffect(() => {
        console.log("statistic mount");
        getFullStatistic();
        getLogsSize();
        getVisitCountByMonth();
        //getModemsLifetime();
    }, []);

    function getFullStatistic() {
        APIRequestGet('/statistic/getFullStatistic', {
            schema: FullStatisticSchema,
            logSuccess: true
        }).then((result) => {
            setUniqueVisitsByDay(result.data.uniqueVisitsByDay.map((visit: VisitsByDayData) => {
                return { count: visit.count, name: visit.date.split('T')[0] };
            }));
            setLifetime(result.data.lifetimeStatistic);
        });

        updateLog(logPage);
    }

    function getLogsSize() {
        APIRequestGet('/statistic/getLogsSize', {
            schema: StatisticGetLogsSizeSchema,
            logSuccess: true
        }).then((result) => {
            setLogsSize(result.data);
        });
    }

    function getVisitCountByMonth() {
        APIRequestGet(`/statistic/getVisitCountByMonth`, {
            logSuccess: true
        }).then((result) => {
            setVisitsByMonth(result.data.map((visit, it) => { return { count: visit, name: (it + 1) } }));
        });
    }

    // function getModemsLifetime() {
    //     axios.get('/statistic/getModemsLifeTime')
    //         .then(response => {
    //             setModemsLifetime(response.data);
    //         });
    // }

    function updateLog(page: number) {
        APIRequestGet(`/statistic/getLogs?count=100&page=${page}`, {
            schema: LogInfoListSchema,
            logSuccess: true
        }).then((result) => {
            setLogs(result.data);
        });
    }

    function clearLogs() {
        APIRequestPost('/statistic/clearLogs', {
            logSuccess: true
        });
    }

    function logPageUp() {
        const lp = logPage + 1
        setLogPage(lp)
        updateLog(lp)
    }

    function logPageDown() {
        const lp = logPage - 1
        setLogPage(lp)
        updateLog(lp)
    }

    return (
        <>
            <ConsoleNavMenu />
            <div className='max-width text-page-padding'>
                <p>Уникальные заходы</p>
                <div>
                    {/*<Line options={options} data={data} />*/}
                    <BarChart
                        width={900}
                        height={300}
                        data={uniqueVisitsByDay}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis dataKey="count" />
                        <Tooltip content={CustomTooltip} />
                        <Legend />
                        <Bar dataKey="count" fill="#FF1493" />
                    </BarChart>
                </div>
                <p>Уникальные заходы по месяцам за год</p>
                <div>
                    {/*<Line options={options} data={data} />*/}
                    <BarChart
                        width={900}
                        height={300}
                        data={visitsByMonth}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="count" fill="#2a9a08" />
                    </BarChart>
                </div>
                <div>
                    {lifetime && <p>Уникальных заходов на этой неделе: {lifetime.length}</p>}
                    {lifetime &&
                        <table className='table table-striped' aria-labelledby="tableLabel2">
                            <thead>
                                <tr>
                                    <th>Firmware</th>
                                    <th>Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.values(lifetime.reduce((acc, { firmwareVersion }) => {
                                    acc[firmwareVersion] = acc[firmwareVersion] || { firmwareVersion, count: 0 };
                                    acc[firmwareVersion]['count'] += 1;

                                    return acc;
                                }, {})).map(f =>
                                    <tr key={f.firmwareVersion}>
                                        <td>{firmware.normalizeFirmwareVersion(f.firmwareVersion, 3000)}</td>
                                        <td>{f.count}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>}
                    <p>Время работы на этой неделе:</p>
                    {lifetime != null ?
                        <table className='table table-striped' aria-labelledby="tableLabel">
                            <thead>
                                <tr>
                                    <th>Imei</th>
                                    <th>Lifetime min</th>
                                    <th>Email</th>
                                    <th>Firmware version</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lifetime.map(lifetime =>
                                    <tr key={lifetime.imei}>
                                        <td><Link to={`/statistics/modem?imei=${lifetime.imei}`}>{lifetime.imei}</Link></td>
                                        <td>{lifetime.lifetime.toFixed(2)}</td>
                                        <td>{lifetime.email}</td>
                                        <td>{firmware.normalizeFirmwareVersion(lifetime.firmwareVersion, 3000)}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        : <></>}

                    {modemsLifetime &&
                        <table className='table table-striped' aria-labelledby="tableLabel">
                            <thead>
                                <tr>
                                    <th>Imei</th>
                                    <th>First connect</th>
                                    <th>Last connect</th>
                                    <th>Total days</th>
                                </tr>
                            </thead>
                            <tbody>
                                {modemsLifetime.map(lifetime =>
                                    <tr key={lifetime.imei}>
                                        <td><Link to={`/statistics/modem?imei=${lifetime.imei}`}>{lifetime.imei}</Link></td>
                                        <td>{lifetime.firstConnectTime}</td>
                                        <td>{lifetime.lastConnectTime}</td>
                                        <td>{lifetime.totalDays}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>}
                </div>
                <div>
                    <p>Информация по модемам:</p>
                    <Button href='/statistics/modems'>Перейти</Button>
                </div>
                <div style={{ marginTop: "50px" }}>
                    <p>Logs:</p>
                    <div className='logs-info'>
                        <p>Logs size: {(logsSize / 1024 / 1024).toFixed(2)} MB</p>
                        <Button style={{ backgroundColor: "#c21b1b" }} onClick={clearLogs}>Очистить</Button>
                    </div>

                    <div className='nav-buttons'>
                        <Button disabled={logPage <= 0} onClick={logPageDown}>{logPage - 1}</Button>
                        <div style={{ alignItems: "center", justifyItems: "center", display: "flex", width: "100%", marginLeft: "40px" }}>{logPage}</div>
                        <Button onClick={logPageUp}>{logPage + 1}</Button>
                    </div>
                    {logs != null ?
                        <table className='table table-striped' aria-labelledby="tableLabel" style={{ tableLayout: "fixed" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "220px" }}>Time</th>
                                    <th style={{ width: "40px" }}>Lvl</th>
                                    <th style={{ width: "150px" }}>Machine</th>
                                    <th>Message</th>
                                    <th>Trace</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.map(l =>
                                    <tr key={l.time}>
                                        <td>{l.time}</td>
                                        <td>{l.level}</td>
                                        <td>{l.machineName}</td>
                                        <td style={{ fontSize: "15px" }}>{l.message}</td>
                                        <td style={{ fontSize: "15px" }}>{l.trace}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        : <></>
                    }
                    <div className='nav-buttons'>
                        <Button disabled={logPage <= 0} onClick={logPageDown}>{logPage}</Button>
                        <div style={{ alignItems: "center", justifyItems: "center", display: "flex", width: "100%", marginLeft: "40px" }}>{logPage + 1}</div>
                        <Button onClick={logPageUp}>{logPage + 2}</Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Statistic;